<div class="map-title">{{title}}</div>
<div id="map-{{id}}"></div>
